import { render, staticRenderFns } from "./deliveryDialog.vue?vue&type=template&id=1d99e6e4&scoped=true"
import script from "./deliveryDialog.vue?vue&type=script&lang=js"
export * from "./deliveryDialog.vue?vue&type=script&lang=js"
import style0 from "./deliveryDialog.vue?vue&type=style&index=0&id=1d99e6e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d99e6e4",
  null
  
)

export default component.exports